;
jQuery(function ($) {
    var isCalculating = false;

    // Mapeamento de UFs brasileiras para nomes de província
    var ufToState = {
        "AC": "Acre", "AL": "Alagoas", "AM": "Amazonas", "AP": "Amapá",
        "BA": "Bahia", "CE": "Ceará", "DF": "Distrito Federal", "ES": "Espírito Santo",
        "GO": "Goiás", "MA": "Maranhão", "MG": "Minas Gerais", "MS": "Mato Grosso do Sul",
        "MT": "Mato Grosso", "PA": "Pará", "PB": "Paraíba", "PE": "Pernambuco",
        "PI": "Piauí", "PR": "Paraná", "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte",
        "RO": "Rondônia", "RR": "Roraima", "RS": "Rio Grande do Sul", "SC": "Santa Catarina",
        "SE": "Sergipe", "SP": "São Paulo", "TO": "Tocantíns"
    };

    function formatMoneyBR(cents) {
        if (cents == 0 || cents === "0" || cents === "0.00" || cents === "0,00") {
            return "Grátis";
        }
        if (typeof cents === "string") {
            var parsed = parseFloat(cents.replace(",", "."));
            if (!isNaN(parsed)) cents = Math.round(parsed * 100);
        }
        var format = window.moneyformat || "R$ {{amount_with_comma_separator}}";
        if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
            var formatted = Shopify.formatMoney(cents, format);
            if (formatted.indexOf("R$ 0,00") > -1 || formatted.indexOf(" 0,00") > -1 && cents == 0) {
                return "Grátis";
            }
            return formatted;
        }
        var val = (cents / 100).toFixed(2).replace(".", ",");
        return "R$ " + val;
    }

    function getDeliveryDateText(rate) {
        var nameLower = (rate.name || "").toLowerCase();

        // 1. Motoboy / Local delivery / 0 dias
        if (nameLower.indexOf("local") > -1 || nameLower.indexOf("motoboy") > -1) {
            return "Entrega em até 2 horas úteis";
        }
        if (rate.delivery_days && rate.delivery_days.length > 0 && rate.delivery_days[0] === 0) {
            return "Entrega em até 2 horas úteis";
        }

        // 2. Extração de quantidade de dias
        var days = null;
        if (rate.delivery_days && rate.delivery_days.length > 0 && rate.delivery_days[0] != null && rate.delivery_days[0] !== "") {
            days = parseInt(rate.delivery_days[rate.delivery_days.length - 1] || rate.delivery_days[0], 10);
        } else if (rate.delivery_range && rate.delivery_range.length > 0 && rate.delivery_range[0] != null) {
            days = parseInt(rate.delivery_range[rate.delivery_range.length - 1] || rate.delivery_range[0], 10);
        } else if (rate.delivery_date) {
            var d = new Date(rate.delivery_date);
            if (!isNaN(d.getTime())) {
                var dd = ("0" + d.getDate()).slice(-2);
                var mm = ("0" + (d.getMonth() + 1)).slice(-2);
                return "Chega até " + dd + "/" + mm;
            }
        }

        // 3. Extração a partir do nome da taxa (ex: "PAC (7 dias úteis)", "Sedex - 3 dias", "5 a 8 dias")
        if (days === null && rate.name) {
            var match = rate.name.match(/(\d+)\s*(?:a|à|-|até)?\s*(\d+)?\s*dias?/i);
            if (match) {
                days = parseInt(match[2] || match[1], 10);
            } else {
                // Fallbacks padrão por transportadora no Brasil
                if (nameLower.indexOf("sedex") > -1) {
                    days = 3;
                } else if (nameLower.indexOf("pac") > -1) {
                    days = 7;
                } else if (nameLower.indexOf("jadlog") > -1) {
                    days = 7;
                } else if (nameLower.indexOf("express") > -1 || nameLower.indexOf("rápido") > -1) {
                    days = 3;
                } else if (nameLower.indexOf("frete") > -1 || nameLower.indexOf("econômico") > -1 || nameLower.indexOf("padrão") > -1) {
                    days = 7;
                }
            }
        }

        // 4. Cálculo da data somando dias úteis (desconsidera sábado e domingo)
        if (days !== null && !isNaN(days) && days > 0) {
            var target = new Date();
            var added = 0;
            while (added < days) {
                target.setDate(target.getDate() + 1);
                var dayOfWeek = target.getDay();
                if (dayOfWeek !== 0 && dayOfWeek !== 6) { // 0 = Domingo, 6 = Sábado
                    added++;
                }
            }
            var dayStr = ("0" + target.getDate()).slice(-2);
            var monthStr = ("0" + (target.getMonth() + 1)).slice(-2);
            return "Chega até " + dayStr + "/" + monthStr;
        }

        return "Consulte o prazo na finalização";
    }

    function getDisplayName(rate) {
        var name = rate.name || "Frete";
        if (name.toLowerCase() === "local delivery") {
            return "Motoboy RJ";
        }
        // Remove texto de dias entre parênteses do título para ficar mais limpo
        return name.replace(/\s*\(\s*\d+.*?\)/g, "").trim();
    }

    function renderFeedback(success, rates, errorMsg) {
        var templateEl = $("#shipping-calculator-response-template");
        var wrapper = $("#wrapper-response");
        if (!templateEl.length || !wrapper.length) return;

        var data = {
            success: !!success,
            rates: rates || [],
            errorFeedback: errorMsg || ""
        };

        if (typeof _ !== "undefined" && typeof _.template === "function") {
            var compiled = _.template($.trim(templateEl.text()))(data);
            wrapper.html(compiled).show();
        }
    }

    function cleanupCart(wasEmpty, variantId, originalQty, callback) {
        if (wasEmpty) {
            $.ajax({
                type: "POST",
                url: "/cart/clear.js",
                dataType: "json",
                complete: function () {
                    if (typeof callback === "function") callback();
                }
            });
        } else {
            // Se o carrinho já tinha itens antes, restaura a quantidade original da variante
            if (variantId) {
                $.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: { id: variantId, quantity: originalQty },
                    dataType: "json",
                    complete: function () {
                        if (typeof callback === "function") callback();
                    }
                });
            } else {
                if (typeof callback === "function") callback();
            }
        }
    }

    function pollShippingRates(shippingAddress, attemptsLeft, callback) {
        if (attemptsLeft <= 0) {
            callback(null, "Tempo limite ao consultar o frete. Tente novamente.");
            return;
        }

        $.ajax({
            url: "/cart/async_shipping_rates",
            dataType: "json",
            success: function (response, textStatus, xhr) {
                if (xhr.status === 200 && response.shipping_rates) {
                    callback(response.shipping_rates, null);
                } else {
                    setTimeout(function () {
                        pollShippingRates(shippingAddress, attemptsLeft - 1, callback);
                    }, 500);
                }
            },
            error: function (xhr) {
                callback(null, "Erro na resposta do cálculo de frete.");
            }
        });
    }

    function calcularFrete() {
        if (isCalculating) return;

        var zipInput = $("#address_zip");
        var rawZip = (zipInput.val() || "").replace(/\D/g, "");

        if (rawZip.length !== 8) {
            renderFeedback(false, [], "Por favor, digite um CEP válido com 8 dígitos.");
            return;
        }

        var btn = $(".get-rates-custom");
        isCalculating = true;
        btn.prop("disabled", true).addClass("loading").val("CALCULANDO...");
        $("#shipping-calculator2 .loading").addClass("load");
        $("#wrapper-response").empty().hide();

        // 1. Consulta ViaCEP
        $.getJSON("https://viacep.com.br/ws/" + rawZip + "/json/?callback=?", function (dados) {
            if ("erro" in dados || !dados.uf) {
                isCalculating = false;
                btn.prop("disabled", false).removeClass("loading").val("CALCULAR");
                $("#shipping-calculator2 .loading").removeClass("load");
                renderFeedback(false, [], "CEP não encontrado. Verifique os números digitados.");
                return;
            }

            var uf = dados.uf.toUpperCase();
            var stateName = ufToState[uf] || dados.localidade || uf;

            // Atualiza selects ocultos
            $('[name="address[country]"]').val("Brazil");
            if ($('[name="address[province]"] option[value="' + stateName + '"]').length) {
                $('[name="address[province]"]').val(stateName);
            }

            // 2. Obtém a variante ativa
            var variantId = $('form[action*="/cart/add"] [name="id"]').val() || $("#variantid").val();

            // 3. Consulta estado atual do carrinho
            $.getJSON("/cart.js", function (cart) {
                var originalItems = cart.items || [];
                var matching = originalItems.find(function (it) { return it.id == variantId; });
                var originalQty = matching ? matching.quantity : 0;
                var wasEmpty = (cart.item_count === 0);

                // Adiciona temporariamente a variante ao carrinho se o carrinho estiver vazio
                var addPromise = wasEmpty && variantId
                    ? $.ajax({ type: "POST", url: "/cart/add.js", data: { id: variantId, quantity: 1 }, dataType: "json" })
                    : Promise.resolve();

                addPromise.then(function () {
                    var shippingAddress = {
                        zip: rawZip,
                        country: "Brazil",
                        province: stateName
                    };

                    // Prepara o cálculo de frete no Shopify
                    $.ajax({
                        type: "POST",
                        url: "/cart/prepare_shipping_rates",
                        data: $.param({ shipping_address: shippingAddress }),
                        success: function () {
                            pollShippingRates(shippingAddress, 20, function (rates, err) {
                                // Limpa imediatamente o item temporário do carrinho
                                cleanupCart(wasEmpty, variantId, originalQty, function () {
                                    isCalculating = false;
                                    btn.prop("disabled", false).removeClass("loading").val("CALCULAR");
                                    $("#shipping-calculator2 .loading").removeClass("load");

                                    if (err || !rates) {
                                        renderFeedback(false, [], err || "Não foi possível obter opções de frete.");
                                    } else {
                                        // Formata as taxas
                                        var processedRates = rates.map(function (rate) {
                                            return {
                                                name: rate.name,
                                                displayName: getDisplayName(rate),
                                                price: formatMoneyBR(rate.price),
                                                delivery_text: getDeliveryDateText(rate)
                                            };
                                        });
                                        renderFeedback(true, processedRates, null);
                                    }
                                });
                            });
                        },
                        error: function () {
                            cleanupCart(wasEmpty, variantId, originalQty, function () {
                                isCalculating = false;
                                btn.prop("disabled", false).removeClass("loading").val("CALCULAR");
                                $("#shipping-calculator2 .loading").removeClass("load");
                                renderFeedback(false, [], "Erro ao comunicar com o servidor de frete.");
                            });
                        }
                    });
                }).catch(function () {
                    isCalculating = false;
                    btn.prop("disabled", false).removeClass("loading").val("CALCULAR");
                    $("#shipping-calculator2 .loading").removeClass("load");
                    renderFeedback(false, [], "Não foi possível inicializar o cálculo de frete.");
                });
            }).fail(function () {
                isCalculating = false;
                btn.prop("disabled", false).removeClass("loading").val("CALCULAR");
                $("#shipping-calculator2 .loading").removeClass("load");
                renderFeedback(false, [], "Erro ao consultar carrinho.");
            });
        }).fail(function () {
            isCalculating = false;
            btn.prop("disabled", false).removeClass("loading").val("CALCULAR");
            $("#shipping-calculator2 .loading").removeClass("load");
            renderFeedback(false, [], "Serviço de consulta de CEP indisponível no momento.");
        });
    }

    // Eventos
    $(document).on("keypress", "#address_zip", function (event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            calcularFrete();
        }
    });

    $(document).on("click", "#shipping-calculate-btn, .get-rates-custom", function (e) {
        e.preventDefault();
        calcularFrete();
    });

    // Atualiza #variantid quando a variante for trocada na página
    document.addEventListener("variant:update", function (e) {
        if (e.detail && e.detail.variant && e.detail.variant.id) {
            $("#variantid").val(e.detail.variant.id);
        }
    });
});

